import React, { useEffect, useState } from 'react';
import InfoIconComponent from '../../InfoIcon';
import style from './EntryTacticsModules.module.css';
import PropTypes from 'prop-types';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import LimitOrderDocs from '../../../../documentation/LimitOrderDocumentation';

function LimitOrderModule({ state, top }) {
  const [limitOrder, dispatchLimitOrder, , setLimitOrderEnabled] = state;
  const [amountDisplay, setAmountDisplay] = useState('');
  const [offsetDisplay, setOffsetDisplay] = useState('');
  const [limitOrderPriceDisplay, setLimitOrderPriceDisplay] = useState('');

  useEffect(() => {
    setLimitOrderEnabled(true);
  }, []);

  useEffect(() => {
    setAmountDisplay(limitOrder.quantityBasisValue ?? 0);
    setOffsetDisplay(Number(limitOrder.offsetFromSetupPrice) * 100 ?? 0);
    setLimitOrderPriceDisplay(limitOrder.limitPrice ?? 0);
  }, [limitOrder]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={LimitOrderDocs} /> Limit Order
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>
            {top.quantityBasis === 'DOLLARS' ? 'Dollar' : 'Qty.'} Amount
          </p>
          <NumberInputWithUnit
            inputWidth="5em"
            direction="left"
            type="number"
            value={amountDisplay}
            setValue={setAmountDisplay}
            onBlur={(value) =>
              dispatchLimitOrder({ quantityBasisValue: value })
            }
          >
            {top.quantityBasis === 'DOLLARS' ? '$' : '#'}
          </NumberInputWithUnit>
        </div>

        <div className={style.inputAndLabel}>
          <p>Offset</p>
          <NumberInputWithUnit
            direction="right"
            type="number"
            value={offsetDisplay}
            setValue={setOffsetDisplay}
            onBlur={(value) =>
              dispatchLimitOrder({ offsetFromSetupPrice: Number(value) / 100 })
            }
          >
            %
          </NumberInputWithUnit>
        </div>

        <div className={style.inputAndLabel}>
          <p>Limit Price</p>
          <NumberInputWithUnit
            inputWidth="5em"
            direction="left"
            type="number"
            value={limitOrderPriceDisplay}
            setValue={setLimitOrderPriceDisplay}
            onBlur={(value) => dispatchLimitOrder({ limitPrice: value })}
          >
            $
          </NumberInputWithUnit>
        </div>
      </div>
    </div>
  );
}
LimitOrderModule.propTypes = {
  state: PropTypes.array.isRequired,
  top: PropTypes.object.isRequired,
};
export default LimitOrderModule;
